import './CallTimeClock.styles.scss';

import { Tooltip } from 'primereact/tooltip';
import React, { FC, useEffect, useMemo, useRef, useState } from 'react';

import commonStore from '../../store/CommonStore';
import { dateFromString, formatToMinutesSeconds } from '../../utils/date.utils';
import { CallTimeClockProps } from './CallTimeClock.types';

const CallTimeClock: FC<CallTimeClockProps> = ({
  tableId,
  pid,
  country,
  callTime,
}) => {
  const [remainingTime, setRemainingTime] = useState<number>(0);
  const [remainingHandsCount, setRemainingHandsCount] = useState<number>(0);

  const formattedTime = useMemo(
    () => formatToMinutesSeconds(remainingTime),
    [remainingTime],
  );

  const interval = useRef<NodeJS.Timer>(null);

  const calculateRemainingTime = (): number => {
    if (!callTime.endTime) {
      return 0;
    }
    const now = new Date();

    const timeLeft =
      dateFromString(callTime.endTime).getTime() -
      now.getTime() +
      commonStore.timeSift;
    setRemainingTime(timeLeft > 0 ? timeLeft : 0);
    if (timeLeft <= 0) {
      clearInterval(interval.current);
    }
    return timeLeft;
  };

  const calculateRemainingHandsCount = (): void => {
    setRemainingHandsCount(callTime.handsCount);
  };

  useEffect(() => {
    if (callTime.endTime || callTime.startTime) {
      const remainingTime = calculateRemainingTime();
      if (remainingTime > 0) {
        interval.current = setInterval(calculateRemainingTime, 1000);
      }
      return () => clearInterval(interval.current);
    } else if (callTime.handsCount !== null) {
      return calculateRemainingHandsCount();
    }
  }, [callTime]);

  const renderCallTimeValue = (): React.ReactNode => {
    if (remainingTime > 0) {
      return <p>{formattedTime}</p>;
    } else if (remainingHandsCount > 0) {
      return <p>{remainingHandsCount}</p>;
    }
    return null;
  };

  return (
    <div
      className="CallTimeClock-Component"
      style={{ top: country ? '23%' : '7%' }}
    >
      <Tooltip
        className="call-time-tooltip"
        target={`#call-time-${tableId}-${pid}`}
        content="Call time"
      />
      <div id={`call-time-${tableId}-${pid}`}>
        <i className="pi pi-clock" />
        {renderCallTimeValue() ?? <p className="call-time-end">END</p>}
      </div>
    </div>
  );
};

export default CallTimeClock;
